import { type InputHTMLAttributes, forwardRef, useId } from 'react';

export interface DateInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: string;
  inline?: boolean;
  width?: string;
}

export const DateInput = forwardRef<HTMLInputElement, DateInputProps>(({ label, inline = false, width = '150px', className, id, ...props }, ref) => {
  const generatedId = useId();
  const inputId = id || generatedId;

  if (inline) {
    return (
      <div className="d-flex align-items-center gap-2">
        {label && (
          <label htmlFor={inputId} className="form-label mb-0 small">
            {label}
          </label>
        )}
        <input ref={ref} id={inputId} type="date" className={`form-control form-control-sm ${className || ''}`} style={{ width }} {...props} />
      </div>
    );
  }

  return (
    <div className="mb-3">
      {label && (
        <label htmlFor={inputId} className="form-label">
          {label}
        </label>
      )}
      <input ref={ref} id={inputId} type="date" className={`form-control ${className || ''}`} {...props} />
    </div>
  );
});

DateInput.displayName = 'DateInput';
